<template>
    <el-dialog
      class="dialog"
      :visible.sync="dialogShareVisible"
      :before-close="handleClose"
      :show-close="false"
      title="分享作品"
      >
      <el-image style="width: 22px; height: 22px;cursor: pointer;" 
          class="close"
          :src="require('../assets/img/share/close.png')"
          fit="contain" 
          @click="handleClose"
          >
        <div slot="placeholder" class="image-slot"></div>
      </el-image>
        <div style="background-color: #252739;font-size: 0;" ref="bePicture">
          <el-image 
            fit="fill" 
            style="margin: 0 auto !important;;width: 330px;;margin: 0 auto 5px;max-height: 520px; " 
            :src="img"
            v-if="img"
            crossorigin="anonymous"
          >
          </el-image>

          <div class="d-flex" style="height: 126px;border-radius: 0px 0px 10px 10px;">
            <div class="l d-flex" style="width: 220px;padding-left: 20px;height: 120px;flex-direction: column; justify-content: center;" >
              <div style="height: 36px;margin-top: 10px;align-items: center ;" class="d-flex">
                <div style="height: 36px;width: 36px;border-radius: 50%;background: #111225;justify-content: center;align-items: center;" class="d-flex">
                  <el-image style="width: 22px; height: 22px;cursor: pointer;" 
                      :src="require('../assets/img/logo.png')"
                      fit="contain" >
                    <div slot="placeholder" class="image-slot"></div>
                  </el-image>
                </div>
                <span style="font-size: 16px;font-weight: 500;color: #FFFFFF;margin-left: 5px;">Boser AI</span>
              </div>
              <div  style="height: 17px;font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;color: #CACAD4;line-height: 17px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;margin-top: 10px;"  >
                {{  shareValue }}
              </div>
            </div>
            <div class="r">
              <div style="width: 98px;height: 98px;background-color: #fff;padding: 3px;box-sizing: border-box;justify-content: center;align-items: center;" class="d-flex">
                <qrcodevue :value="`https://boserai.com/?share_url=${ shareImgMd5 }`"  :level="'L'" :size="90" v-if="imgUrl" style="margin: 2px;"></qrcodevue>
              </div>
              <div style="font-size: 11px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;text-align: center;">
                免费作图
              </div>
            </div>

          </div>
        </div>
        <div class="d-flex" style="margin-top: 35px;background-color: rgba(0,0,0,0.1);justify-content: space-around;flex-direction: row;" >
          <div style="width: 70px;height: 70px;text-align: center;" @click="keepPicture">
            <el-image style="width: 44px; height: 44px;cursor: pointer;" 
                :src="require('../assets/img/share/download.png')"
                fit="contain" >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <div style="font-size: 14px;font-weight: 500;color: #FFFFFF;line-height: 20px;">
              保存至本地
            </div>
          </div>


          <div style="width: 70px;height: 70px;text-align: center;" @click="copyPicUrl">
            <el-image style="width: 44px; height: 44px;cursor: pointer;" 
                :src="require('../assets/img/share/link.png')"
                fit="contain" >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <div style="font-size: 14px;font-weight: 500;color: #FFFFFF;line-height: 20px;">
              生成链接
            </div>
          </div>
        </div>


    </el-dialog>
</template>


<script>
import html2canvas from 'html2canvas'
import { copyToClip , decompress } from "@/utils/bose";


export default {
    props : {
      dialogShareVisible: {
        type: Boolean ,
        default: false , 
      },
      imgUrl : {
        type: String ,
        default: '' , 
      },
      shareValue : {
        type: String ,
        default: '' , 
      },
      shareImgMd5 : {
        type: String ,
        default: '' , 
      }
    }, 
    data() {
      return {
        img : '' ,

      }
    },

    mounted(){
      // this._img = this.getBase64( this.imgUrl )
    },
    components: {
      html2canvas
    },
    methods : {
      handleClose(done) {
        this.$emit('update:dialogShareVisible',  false ) // 传递更新数值
      } ,
      //保存图片
      keepPicture() {
        html2canvas(this.$refs.bePicture).then(canvas => {


          // 获取生成的图片的url,并设置为png格式
          const imgUrl = canvas.toDataURL("png"); 
          let creatDom = document.createElement('a')
          document.body.appendChild(creatDom)
          creatDom.href = imgUrl
          //设置生成图片的名称
          creatDom.download = 'BOSERAI'
          creatDom.click()
        })
      },
      toBase64(imgUrl) {
          // 一定要设置为let，不然图片不显示
          const image = new Image();
          // 解决跨域问题
          image.setAttribute('crossOrigin', 'anonymous');
          const imageUrl = imgUrl;
          image.src = imageUrl
          // image.onload为异步加载
          image.onload = () => {
              var canvas = document.createElement('canvas');
              canvas.width = image.width;
              canvas.height = image.height;
              var context = canvas.getContext('2d');
              context.drawImage(image, 0, 0, image.width, image.height);
              var quality = 0.8;
              // 这里的dataurl就是base64类型  
              // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
              const dataurl = canvas.toDataURL('image/jpeg', quality);
              this.img  = dataurl
          }
      },
      copy(text) {
        copyToClip(text).then(res => {
          this.$toast.open({
            message: '生成成功并已复制!',
            position: 'top',
            duration: 3000,
            type: 'success',
          });
        });
      },
      copyPicUrl(){
        this.copy( `https://boserai.com/?share_url=${ this.shareImgMd5 }`   );
      },

    },

    watch: {
      // 如果 `question` 发生改变，这个函数就会运行
      imgUrl: function (newQuestion, oldQuestion) {
         this.toBase64( (  this.imgUrl ) )
      }
    },
}


</script>


<style lang="scss" scoped>  
::v-deep .el-dialog {
  width: 330px;
  // height: 520px;
  position: relative;
  // background-color: palegreen;
  background-color:rgba(0,0,0,0.1) !important;
  display: flex;
  flex-direction: column;
  // align-items: center;
  // margin: 0 !important;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
  margin-top: 10vh !important;

  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding:  0;
  }

  .close {
    position: absolute;
    top: -28px;
    right: 0;

  }
}



::v-deep  .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}




</style>